module.exports = __webpack_public_path__ + "static/media/stylesosimple.04f178f4.png";